export default function Boundary() {
  return (
    <section className="boundary" id="limits">
      <div className="shell boundary-inner">
        <div>
          <p className="label">Bounded workflow</p>
          <h2>Before you convert</h2>
          <p>To keep each conversion within the stated limits, this review design shows specific processing constraints.</p>
          <ul>
            <li>20 files maximum per batch</li>
            <li>30 MB maximum per file</li>
            <li>12,000 px longest side</li>
            <li>Files are processed one at a time</li>
            <li>Some HEIF encodings may not be supported</li>
          </ul>
        </div>
        <div className="monogram" aria-hidden="true">H→</div>
      </div>
    </section>
  )
}
